// extracted by mini-css-extract-plugin
export default {"page":"GR-z","cartModal":"HR-z","checkout":"IR-z","placeholder":"JR-z","account":"KR-z"};